import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIBaseResponse } from '..';
import { handleListFetch } from '../apiHelpers';

import {
    AclAccess,
    APIAclAccessDelete,
    APIAclAccessGetList,
    APIAclAccessPost,
    APIAclAccessPostParams,
    APIAclAccessPostResponse,
    APIAclAccessPut,
    APIAclAccessPutParams } from './AclAccesses.api';

export const fetchAclAccesses = createAsyncThunk('aclAccesses/fetchAclAccesses', async (item: { tenantId: string, signal?: AbortSignal }) => {
    const response = await APIAclAccessGetList(item);
    return response.data;
});

export type PostAclAccessThunkResponse = {
    item: APIAclAccessPostParams,
    response: APIAclAccessPostResponse,
    rows: AclAccess[]
}

export const postAclAccess = createAsyncThunk('aclAccesses/postAclAccess', async (item: APIAclAccessPostParams) => {
    const response = await APIAclAccessPost(item);
    const rows = await handleListFetch(APIAclAccessGetList( { tenantId: item.tenantId }));
    return {
        item,
        response,
        rows
    };
});

export const deleteAclAccess = createAsyncThunk('aclAccesses/deleteAclAccess', async (item: { tenantId: string, aclAccessId: string }) => {
    const response = await APIAclAccessDelete(item);
    const rows = await handleListFetch(APIAclAccessGetList({ tenantId: item.tenantId }));
    return {
        item,
        response,
        rows
    };
});

export type PutAclAccessThunkResponse = {
    item: APIAclAccessPutParams,
    response: APIBaseResponse,
    rows: AclAccess[]
}

export const putAclAccess = createAsyncThunk('aclAccesses/putAclAccess', async (item: APIAclAccessPutParams) => {
    const response = await APIAclAccessPut(item);
    const rows = await handleListFetch(APIAclAccessGetList( { tenantId: item.tenantId }));
    return {
        item,
        response,
        rows
    };
});
